import { FC } from 'react'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { Col } from 'antd'

interface Props {
  label: string
  margin?: 'no' | 'bigger'
  align?: 'top' | 'middle'
}

export const InviteModalRow: FC<Props> = ({ label, margin, align = 'middle', children }) => {
  const setMargin = (m: 'no' | 'bigger' | undefined) => {
    if (m === 'no') {
      return undefined
    } else if (m === 'bigger') {
      return 'xxl'
    } else {
      return 's'
    }
  }

  return (
    <PerFlexRow align={align} mb={setMargin(margin)}>
      <Col span={4}>
        <PerText color="secondary">{label}</PerText>
      </Col>
      <Col span={20}>{children}</Col>
    </PerFlexRow>
  )
}
